'use strict';

// チームリーグ「C 一括情報編集」画面のJS
// turbolinks:load でバインド、turbolinks:before-cache でクリーンアップ

(function () {
  var dirtySet = new Set();
  let newTeamCounter = 0;
  let newTeamDirty = false;
  let roleDirty = false;
  let currentAddTarget = null;
  let iconsData = {};
  let i18n = {};
  let rolePlayedSortMode = 'recent';
  let rolePlayedSelectedIds = [];
  var configData = null;
  var pendingUrl = null;
  var bypassGuard = false;

  // モバイル判定（≤767px）
  var mobileQuery = window.matchMedia('(max-width: 767px)');

  // ブラウザ離脱（リロード・閉じる・戻るなど）を検知してガードする
  function onBeforeUnload(e) {
    if ((dirtySet.size > 0 || newTeamDirty || roleDirty) && !bypassGuard) {
      e.preventDefault();
      e.returnValue = '';
      return '';
    }
  }

  // 設定データを読み込む
  function loadConfig() {
    var el = document.getElementById('bulk-edit-config');
    if (!el) return null;
    try {
      return JSON.parse(el.dataset.config);
    } catch (e) {
      return null;
    }
  }

  // アイコンデータを読み込む
  function loadIcons() {
    const el = document.getElementById('bulk-edit-config');
    if (!el) return {};
    try { return JSON.parse(el.dataset.icons); }
    catch (e) { return {}; }
  }

  // i18nラベルを読み込む
  function loadI18n() {
    const el = document.getElementById('bulk-edit-config');
    if (!el) return {};
    try { return JSON.parse(el.dataset.i18n || '{}'); }
    catch (e) { return {}; }
  }

  // アコーディオン状態を適用する（モバイル: 折りたたみ制御 / PC: 全展開）
  function applyAccordionState() {
    var cards = document.querySelectorAll('.team-card');
    var pageBulk = document.querySelector('.page--bulk');

    if (!mobileQuery.matches) {
      // PC: 全カードを展開し、アコーディオン属性を除去する
      cards.forEach(function (card) {
        card.classList.remove('is-collapsed');
        var header = card.querySelector('.tc-header');
        if (header) {
          header.removeAttribute('role');
          header.removeAttribute('tabindex');
          header.removeAttribute('aria-expanded');
        }
      });
      return;
    }

    // モバイル: エラー再表示かを判定する
    var hasErrors = pageBulk && pageBulk.dataset.hasErrors === 'true';

    cards.forEach(function (card) {
      var isDirty = card.classList.contains('dirty');
      var shouldExpand = isDirty || hasErrors;

      if (shouldExpand) {
        card.classList.remove('is-collapsed');
      } else {
        card.classList.add('is-collapsed');
      }

      // ヘッダーにアクセシビリティ属性を設定する
      var header = card.querySelector('.tc-header');
      if (header) {
        header.setAttribute('role', 'button');
        header.setAttribute('tabindex', '0');
        header.setAttribute('aria-expanded', shouldExpand ? 'true' : 'false');
      }
    });
  }

  // カードの開閉をトグルする（モバイルのみ動作）
  function toggleCard(card) {
    if (!mobileQuery.matches) return;

    card.classList.toggle('is-collapsed');
    var isExpanded = !card.classList.contains('is-collapsed');

    var header = card.querySelector('.tc-header');
    if (header) {
      header.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
    }
  }

  // dirty状態を更新し保存バーを更新する
  function markDirty(card) {
    var teamId = card.dataset.teamId;
    card.classList.add('dirty');
    dirtySet.add(teamId);
    updateSaveBar();

    // モバイルで折りたたまれていたカードを展開する
    if (mobileQuery.matches && card.classList.contains('is-collapsed')) {
      card.classList.remove('is-collapsed');
      var header = card.querySelector('.tc-header');
      if (header) {
        header.setAttribute('aria-expanded', 'true');
      }
    }
  }

  // 保存バーの表示を更新する
  function updateSaveBar() {
    var saveBar = document.getElementById('saveBar');
    var changeNote = document.getElementById('changeNote');
    if (!saveBar || !changeNote) return;

    const hasDirty = dirtySet.size > 0 || newTeamDirty || roleDirty;
    if (hasDirty) {
      const parts = [];
      if (dirtySet.size > 0) parts.push(window.Janreco.pluralize(i18n.changeDirtyTeams, dirtySet.size));
      if (newTeamDirty) parts.push(i18n.changeAddTeam);
      if (roleDirty) parts.push(i18n.changeRole);
      changeNote.textContent = parts.join(i18n.changeSeparator) + i18n.changeSuffix;
      saveBar.classList.add('show');
    } else {
      saveBar.classList.remove('show');
    }
  }

  // カラーをカードに適用する
  function applyColor(card, hex) {
    if (!configData) return;

    // コントラスト不足の場合は警告を表示し、色は反映しない（参照実装 team_edit.js に合わせる）
    var warn = card.querySelector('.contrast-warn');
    var sufficient = !window.TeamColorContrast || window.TeamColorContrast.isSufficient(hex);
    if (warn) warn.classList.toggle('show', !sufficient);
    if (!sufficient) return;

    // CSS変数でカードのテーマカラーを更新する
    card.style.setProperty('--team-color', hex);

    // カスタムカラーinputの値を更新する
    var customColor = card.querySelector('.tc-custom-color');
    if (customColor) customColor.value = hex;

    // ラベル行のカラーコード表示を更新する
    var colorCounter = card.querySelector('.tc-color-counter');
    if (colorCounter) colorCounter.textContent = hex.toUpperCase();

    markDirty(card);
  }

  // ロゴファイルを検証してプレビューを表示する
  function handleLogoFile(card, file) {
    // ファイル形式チェック
    var allowed = ['image/jpeg', 'image/png', 'image/gif', 'image/webp'];
    if (allowed.indexOf(file.type) === -1) {
      window.TeamUiShared.showToast(i18n.toastInvalidImageFormat, 'warn');
      return false;
    }
    // ファイルサイズチェック（2MB以下）
    if (file.size > 2 * 1024 * 1024) {
      window.TeamUiShared.showToast(i18n.toastImageTooLarge, 'warn');
      return false;
    }

    // FileReaderでプレビューを表示する
    var reader = new FileReader();
    reader.onload = function (e) {
      // tc-logo 円のプレビューを更新する
      var logoBtn = card.querySelector('.tc-logo');
      if (logoBtn) {
        var existingImg = logoBtn.querySelector('img');
        var initial = logoBtn.querySelector('.tc-logo-initial');

        if (existingImg) {
          existingImg.src = e.target.result;
        } else {
          // 頭文字spanをimg要素に置き換える
          var img = document.createElement('img');
          img.src = e.target.result;
          img.alt = '';
          if (initial) {
            initial.replaceWith(img);
          } else {
            logoBtn.appendChild(img);
          }
        }
      }

      // logo-row のプレビュー画像を更新する
      var previewImg = card.querySelector('.logo-preview-img');
      if (previewImg) {
        previewImg.src = e.target.result;
      } else {
        // プレビュー画像を作成してアップロードボタンの前に挿入する
        var newPreviewImg = document.createElement('img');
        newPreviewImg.className = 'logo-preview-img';
        newPreviewImg.alt = i18n.teamLogoAlt;
        newPreviewImg.src = e.target.result;
        var uploadBtn = card.querySelector('.logo-action.upload');
        if (uploadBtn && uploadBtn.parentNode) {
          uploadBtn.parentNode.insertBefore(newPreviewImg, uploadBtn);
        }
        // アップロードボタンのテキストを「変更」に変更する
        if (uploadBtn) {
          var btnNodes = uploadBtn.childNodes;
          for (var i = btnNodes.length - 1; i >= 0; i--) {
            if (btnNodes[i].nodeType === Node.TEXT_NODE) {
              btnNodes[i].textContent = i18n.logoChange;
              break;
            }
          }
        }
        // 削除ボタンを表示する
        var removeBtn = card.querySelector('.logo-action.remove');
        if (removeBtn) {
          removeBtn.hidden = false;
        }
      }

      // remove_logoフラグをリセットする
      var removeFlag = card.querySelector('.tc-remove-logo');
      if (removeFlag) removeFlag.value = '0';

      markDirty(card);
    };
    reader.readAsDataURL(file);
    return true;
  }

  // ロゴを初期文字表示に戻す
  function revertLogoToInitial(card) {
    var logoBtn = card.querySelector('.tc-logo');
    if (!logoBtn) return;

    var existingImg = logoBtn.querySelector('img');
    var nameInput = card.querySelector('.tc-name-input');
    var initial = nameInput ? nameInput.value.charAt(0) : '?';

    if (existingImg) {
      // img要素を頭文字spanに置き換える
      var span = document.createElement('span');
      span.className = 'tc-logo-initial';
      span.textContent = initial;
      existingImg.replaceWith(span);
    }
  }

  // カード1枚を初期化する
  function initCard(card) {
    // jQuery オブジェクトが渡された場合はDOM要素に変換する
    card = card instanceof jQuery ? card[0] : card;

    var teamColor = card.dataset.teamColor;
    // 初期テーマカラーをCSS変数に設定する
    if (teamColor) {
      card.style.setProperty('--team-color', teamColor);
    }

    // チーム名入力イベント
    var nameInput = card.querySelector('.tc-name-input');
    if (nameInput) {
      // 文字数カウンターは components/form_counter.js が更新する
      nameInput.addEventListener('input', function () {
        // ヘッダーのチーム名プレビューを更新する
        var tcName = card.querySelector('.tc-name');
        if (tcName) tcName.textContent = nameInput.value || i18n.teamNameUnset;
        // ロゴ頭文字を更新する
        var initial = card.querySelector('.tc-logo-initial');
        if (initial) initial.textContent = nameInput.value.charAt(0) || '?';
        markDirty(card);
      });
    }

    // 説明文入力イベント
    var descInput = card.querySelector('.tc-desc-input');
    if (descInput) {
      descInput.addEventListener('input', function () {
        var tcDesc = card.querySelector('.tc-desc');
        if (tcDesc) tcDesc.textContent = descInput.value;
        markDirty(card);
      });
    }

    // カラーピッカー入力イベント
    var customColor = card.querySelector('.tc-custom-color');
    if (customColor) {
      customColor.addEventListener('input', function () {
        applyColor(card, customColor.value);
      });
    }

    // ロゴ関連（Proのみ）
    if (configData && configData.isPro) {
      var logoInput = card.querySelector('.tc-logo-input');
      var uploadBtn = card.querySelector('.logo-action.upload');
      var removeBtn = card.querySelector('.logo-action.remove');

      // アップロードボタンのクリックでファイル選択を起動する
      if (uploadBtn && logoInput) {
        uploadBtn.addEventListener('click', function () {
          logoInput.click();
        });
      }

      // ファイル選択時の処理
      if (logoInput) {
        logoInput.addEventListener('change', function () {
          if (logoInput.files && logoInput.files[0]) {
            var ok = handleLogoFile(card, logoInput.files[0]);
            if (!ok) {
              logoInput.value = '';
            }
          }
        });
      }

      // ロゴ削除ボタンの処理
      if (removeBtn && logoInput) {
        removeBtn.addEventListener('click', function () {
          logoInput.value = '';
          var removeFlag = card.querySelector('.tc-remove-logo');
          if (removeFlag) removeFlag.value = '1';
          revertLogoToInitial(card);
          // logo-row のプレビュー画像を削除する
          var previewImg = card.querySelector('.logo-preview-img');
          if (previewImg) previewImg.remove();
          // アップロードボタンのテキストを「アップロード」に戻す
          var btnNodes = uploadBtn ? uploadBtn.childNodes : [];
          for (var i = btnNodes.length - 1; i >= 0; i--) {
            if (btnNodes[i].nodeType === Node.TEXT_NODE) {
              btnNodes[i].textContent = i18n.logoUpload;
              break;
            }
          }
          // 削除ボタンを非表示にする
          removeBtn.hidden = true;
          markDirty(card);
        });
      }
    }
  }

  // 次に使うカラーを選ぶ（未使用の色を返す）
  function pickNextColor() {
    if (!configData || !configData.presetColors || configData.presetColors.length === 0) return '#3B82F6';
    const usedColors = new Set();
    document.querySelectorAll('.team-card').forEach(function(card) {
      const color = card.dataset.teamColor;
      if (color) usedColors.add(color.toLowerCase());
    });
    const unused = configData.presetColors.find(function(c) {
      return !usedColors.has(c.toLowerCase());
    });
    return unused || configData.presetColors[0];
  }

  // チーム数上限ヒントを更新する
  function updateTeamLimitHint() {
    const totalTeams = document.querySelectorAll('.team-card').length;
    const addBtn = document.getElementById('addTeamBtn');
    const hint = document.getElementById('addTeamHint');
    if (addBtn) addBtn.disabled = totalTeams >= configData.teamLimit;
    if (hint) {
      hint.textContent = totalTeams >= configData.teamLimit
        ? window.Janreco.pluralize(i18n.teamLimitReached, configData.teamLimit)
        : window.Janreco.pluralize(i18n.teamCount, totalTeams).replace('%{limit}', configData.teamLimit);
    }
  }

  // 新規チームカードを <template id="new-team-template">（_bulk_edit_card.html.haml）から複製し、jQueryオブジェクトで返す
  // __NEW_ID__ を連番に置き換えてから要素化する。デフォルト名・色は innerHTML に連結せず value / textContent / setAttribute で入れる
  function buildNewTeamCard(idx, defaultName, color) {
    const template = document.getElementById('new-team-template');
    if (!template) return null;

    const wrapper = document.createElement('div');
    wrapper.innerHTML = template.innerHTML.replace(/__NEW_ID__/g, String(idx));
    const card = wrapper.firstElementChild;
    card.dataset.teamColor = color;

    const initial = card.querySelector('.tc-logo-initial');
    if (initial) initial.textContent = defaultName.charAt(0);
    const tcName = card.querySelector('.tc-name');
    if (tcName) tcName.textContent = defaultName;
    const deleteBtn = card.querySelector('.tc-delete-btn');
    if (deleteBtn) deleteBtn.setAttribute('aria-label', i18n.removeAria.replace('%{name}', defaultName));

    const nameInput = card.querySelector('.tc-name-input');
    if (nameInput) {
      nameInput.value = defaultName;
      // 文字数カウンターは入力時に form_counter.js が更新する。初期値だけここで合わせる
      const nameCounter = card.querySelector('[data-form-counter-for="' + nameInput.id + '"]');
      if (nameCounter) nameCounter.textContent = defaultName.length + '/' + nameCounter.dataset.formCounterMax;
    }

    const customColor = card.querySelector('.tc-custom-color');
    if (customColor) customColor.value = color;
    const colorCounter = card.querySelector('.tc-color-counter');
    if (colorCounter) colorCounter.textContent = color.toUpperCase();

    return $(card);
  }

  // チームを追加する
  function addTeam() {
    if (!configData) return;
    const totalTeams = document.querySelectorAll('.team-card').length;
    if (totalTeams >= configData.teamLimit) {
      window.TeamUiShared.showToast(window.Janreco.pluralize(i18n.teamLimitReached, configData.teamLimit), 'warn');
      return;
    }
    const idx = newTeamCounter++;
    const defaultName = i18n.defaultTeamName.replace('%{num}', totalTeams + 1);
    const color = pickNextColor();
    const $card = buildNewTeamCard(idx, defaultName, color);
    if (!$card) return;
    $('#cardsGrid').append($card);
    initCard($card[0]);
    newTeamDirty = true;
    updateSaveBar();
    updateTeamLimitHint();
  }

  // チップ要素を生成する
  function createChipElement(pid, name, role) {
    let bgColor = '#666';
    if (role === 'kuroko') bgColor = '#33404F';
    if (role === 'record_only') bgColor = '#0277BD';

    const $chip = $('<span>', { class: 'tc-member-chip', 'data-player-id': pid || '' });
    const $avatar = $('<span>', { class: 'chip-avatar' }).css('background', bgColor).text(name.charAt(0));
    $chip.append($avatar);
    $chip.append(document.createTextNode(name));

    const btnAttrs = {
      type: 'button',
      class: 'chip-x',
      'aria-label': i18n.removeAria.replace('%{name}', JanrecoUtils.escapeHtml(name))
    };
    if (pid) {
      btnAttrs['data-pid'] = pid;
    } else {
      btnAttrs['data-new-name'] = name;
    }
    const $xBtn = $('<button>', btnAttrs).html(iconsData.chipX || '×');
    $chip.append($xBtn);

    return $chip;
  }

  // チップをカードに追加する
  function addChipToCard(role, pid, name) {
    const $card = $('.special-card[data-role="' + role + '"]');
    const $addChipBtn = $card.find('.tc-add-chip');
    const $chip = createChipElement(pid, name, role);
    $chip.insertBefore($addChipBtn);
    updateRoleCardCount(role);
  }

  // 役割カードのカウントを更新する
  function updateRoleCardCount(role) {
    const $count = $('.special-card[data-role="' + role + '"] .tc-count');
    const n = $('.special-card[data-role="' + role + '"] .tc-member-chip').length;
    $count.text(window.Janreco.pluralize(i18n.people, n));
  }

  // 役割追加タブをアクティブにする
  function activateRoleAddTab(activeTabId) {
    const tabs = [
      { tab: 'roleAddTabName', panel: 'roleAddPanelName' },
      { tab: 'roleAddTabPlayed', panel: 'roleAddPanelPlayed' },
      { tab: 'roleAddTabInvite', panel: 'roleAddPanelInvite' }
    ];
    tabs.forEach(function(t) {
      const tabEl = document.getElementById(t.tab);
      const panelEl = document.getElementById(t.panel);
      if (!tabEl || !panelEl) return;
      if (t.tab === activeTabId) {
        tabEl.classList.add('is-active');
        tabEl.setAttribute('aria-selected', 'true');
        panelEl.hidden = false;
      } else {
        tabEl.classList.remove('is-active');
        tabEl.setAttribute('aria-selected', 'false');
        panelEl.hidden = true;
      }
    });
  }

  // 過去の対戦相手の候補リストを描画する
  function renderRolePlayedPick() {
    const $list = $('#rolePlayedPickList');
    if (!$list.length || !configData) return;

    // 既存のリーグメンバーIDを収集する
    const currentLeaguePlayerIds = configData.currentLeaguePlayerIds || [];

    // 対象カードの既存チップのプレイヤーIDを収集する
    const existingChipIds = [];
    if (currentAddTarget) {
      $('.special-card[data-role="' + currentAddTarget + '"] .tc-member-chip').each(function() {
        const pid = $(this).data('player-id');
        if (pid) existingChipIds.push(parseInt(pid, 10));
      });
    }

    // 除外後の候補リストを作成する
    let players = (configData.playedPlayers || []).filter(function(p) {
      return currentLeaguePlayerIds.indexOf(p.id) === -1 && existingChipIds.indexOf(p.id) === -1;
    });

    // record_only のときはアカウント登録済みのみに絞る
    if (currentAddTarget === 'record_only') {
      players = players.filter(function(p) { return p.hasAccount !== false; });
    }

    // ソートする
    if (rolePlayedSortMode === 'name') {
      players = players.slice().sort(function(a, b) {
        return a.name.localeCompare(b.name, 'ja');
      });
    }

    $list.empty();

    if (players.length === 0) {
      const $empty = $('<p>', { class: 'empty-candidates-note' }).text(
        currentAddTarget === 'record_only'
          ? i18n.playedEmptyAccount
          : i18n.playedAllAdded
      );
      $list.append($empty);
      return;
    }

    players.forEach(function(p) {
      const isSelected = rolePlayedSelectedIds.indexOf(p.id) !== -1;
      let rowClass = 'candidate-row';
      if (isSelected) rowClass += ' selected';
      const $row = $('<div>', {
        class: rowClass,
        'data-pid': p.id
      });
      const $check = $('<span>', { class: 'candidate-check' }).html(iconsData.check || '✓');
      $row.append($check);
      $row.append(document.createTextNode(p.name));
      $list.append($row);
    });
  }

  // 過去の対戦相手の追加ボタンの状態を更新する
  function updateRolePlayedPickBtn() {
    const $btn = $('#rolePlayedPickConfirm');
    const n = rolePlayedSelectedIds.length;
    $btn.text(window.Janreco.pluralize(i18n.addCount, n));
    $btn.prop('disabled', n === 0);
  }

  // タブ切り替え時に選択・並び順をリセットしてから描画
  function resetAndRenderRolePlayedPick() {
    rolePlayedSelectedIds = [];
    rolePlayedSortMode = 'recent';
    renderRolePlayedPick();
    updateRolePlayedPickBtn();
    $('#rolePlayedSortRecent').addClass('is-active');
    $('#rolePlayedSortName').removeClass('is-active');
  }

  // 招待QRコードを読み込む
  function loadRoleInviteQr() {
    if (!configData || !configData.authenticationUrl) return;
    const urlEl = document.getElementById('roleInviteUrl');
    if (urlEl) urlEl.textContent = configData.authenticationUrl;
    const qrEl = document.getElementById('roleInviteQr');
    if (qrEl && !qrEl.dataset.loaded) {
      $.ajax({
        url: '/qr_codes',
        method: 'GET',
        data: { url: configData.authenticationUrl },
        success: function(data) {
          qrEl.innerHTML = data.qr_code;
          qrEl.dataset.loaded = '1';
        },
        error: function() {
          console.error('QRコード生成に失敗しました');
        }
      });
    }
  }

  // CSRFトークンを取得する
  function csrfToken() {
    const meta = document.querySelector('meta[name="csrf-token"]');
    return meta ? meta.content : '';
  }

  // 保存ボタンのクリック処理
  function handleSave() {
    // 既存チームの名前空チェック
    var hasEmptyName = false;
    document.querySelectorAll('.team-card.dirty:not(.tc-new-card)').forEach(function (card) {
      var nameInput = card.querySelector('.tc-name-input');
      if (nameInput && !nameInput.value.trim()) {
        hasEmptyName = true;
      }
    });

    // 仮カードの名前空チェック
    document.querySelectorAll('.team-card.tc-new-card').forEach(function (card) {
      var nameInput = card.querySelector('.tc-name-input');
      if (nameInput && !nameInput.value.trim()) {
        hasEmptyName = true;
      }
    });

    if (hasEmptyName) {
      window.TeamUiShared.showToast(i18n.toastNameMissing, 'warn');
      return;
    }

    // チーム名重複チェック
    var allNameInputs = document.querySelectorAll('.team-card .tc-name-input');
    var nameValues = [];
    var duplicateName = null;
    allNameInputs.forEach(function(input) {
      var val = input.value.trim();
      if (val) {
        if (nameValues.indexOf(val) !== -1) {
          duplicateName = val;
        } else {
          nameValues.push(val);
        }
      }
    });
    if (duplicateName) {
      window.TeamUiShared.showToast(i18n.toastNameDuplicate.replace('%{name}', duplicateName), 'warn');
      return;
    }

    // 非dirty・非仮カードのフィールドをdisabledにして送信から除外
    document.querySelectorAll('.team-card').forEach(function (card) {
      if (!card.classList.contains('dirty') && !card.classList.contains('tc-new-card')) {
        card.querySelectorAll('input, textarea, select').forEach(function (field) {
          field.disabled = true;
        });
      }
    });

    bypassGuard = true;
    document.getElementById('bulk-edit-form').submit();
  }

  // ページを初期化する
  function init() {
    var form = document.getElementById('bulk-edit-form');
    if (!form) return;

    configData = loadConfig();
    iconsData = loadIcons();
    i18n = loadI18n();
    newTeamCounter = 0;
    newTeamDirty = false;
    roleDirty = false;
    currentAddTarget = null;
    rolePlayedSortMode = 'recent';
    rolePlayedSelectedIds = [];
    dirtySet = new Set();
    bypassGuard = false;

    // ブラウザ離脱ガードを登録する
    window.addEventListener('beforeunload', onBeforeUnload);

    // 各チームカードを初期化する
    document.querySelectorAll('.team-card').forEach(function (card) {
      initCard(card);
    });

    // アコーディオン初期状態を適用する
    applyAccordionState();

    // ヘッダークリックで開閉する（イベント委譲）
    $(document).on('click.teamAccordion', '.team-card .tc-header', function () {
      if (!mobileQuery.matches) return;
      var card = this.closest('.team-card');
      if (card) toggleCard(card);
    });

    // キーボード（Enter / Space）でも開閉できるようにする
    $(document).on('keydown.teamAccordion', '.team-card .tc-header', function (e) {
      if (!mobileQuery.matches) return;
      // Enter(13) または Space(32) のみ処理する
      if (e.which !== 13 && e.which !== 32) return;
      if (e.which === 32) {
        // Space によるスクロールを抑止する
        e.preventDefault();
      }
      var card = this.closest('.team-card');
      if (card) toggleCard(card);
    });

    // ブレークポイント跨ぎ時にアコーディオン状態を再適用する
    mobileQuery.addEventListener('change', applyAccordionState);

    // 保存ボタン
    var saveBtn = document.getElementById('saveBtn');
    if (saveBtn) {
      saveBtn.addEventListener('click', handleSave);
    }

    // 変更破棄ボタン
    var discardBtn = document.getElementById('discardBtn');
    if (discardBtn) {
      discardBtn.addEventListener('click', function () {
        bypassGuard = true;
        Turbolinks.visit(window.location.toString(), { action: 'replace' });
      });
    }

    // ページ内リンク遷移の割り込み（未保存変更がある場合に確認シートを表示する）
    $(document).on('click.leaveGuard', '.team-ui-page a[href]', function (e) {
      // 修飾クリック・中クリックは通常遷移させる
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.which === 2) {
        return;
      }
      var href = this.href;
      // hrefが空・fragment・javascript:の場合は無視する
      if (!href || href === '#' || /^javascript:/i.test(href) || /^#/.test(this.getAttribute('href'))) {
        return;
      }
      if (dirtySet.size === 0 && !newTeamDirty && !roleDirty) {
        return;
      }
      e.preventDefault();
      pendingUrl = href;
      window.TeamUiShared.openSheet('leaveConfirmOverlay');
    });

    // 「移動する」ボタン: 離脱を確定する
    var leaveConfirmBtn = document.getElementById('leaveConfirmBtn');
    if (leaveConfirmBtn) {
      leaveConfirmBtn.addEventListener('click', function () {
        bypassGuard = true;
        window.TeamUiShared.closeSheet('leaveConfirmOverlay');
        if (pendingUrl) {
          Turbolinks.visit(pendingUrl);
        }
      });
    }

    // チーム追加ボタン
    const addTeamBtn = document.getElementById('addTeamBtn');
    if (addTeamBtn) {
      addTeamBtn.addEventListener('click', addTeam);
    }
    if (configData) {
      updateTeamLimitHint();
    }

    // 仮カード削除ボタン（イベント委譲）
    $(document).on('click.newTeamDelete', '.tc-delete-btn', function(e) {
      e.stopPropagation();
      const card = this.closest('.team-card.tc-new-card');
      if (!card) return;
      card.remove();
      if (!document.querySelector('.team-card.tc-new-card')) {
        newTeamDirty = false;
      }
      updateSaveBar();
      updateTeamLimitHint();
    });

    // チップ削除（イベント委譲）
    $(document).on('click.chipRemove', '.special-card .chip-x', function(e) {
      e.stopPropagation();
      const chip = this.closest('.tc-member-chip');
      const card = this.closest('.special-card');
      if (!chip || !card) return;
      const pid = this.dataset.pid;
      const newName = this.dataset.newName;
      const role = card.dataset.role;
      const form = document.getElementById('bulk-edit-form');

      if (pid) {
        const addParamName = role === 'kuroko' ? 'add_kuroko_player_ids[]' : 'add_record_only_player_ids[]';
        const addInput = form.querySelector('input[type="hidden"][name="' + addParamName + '"][value="' + pid + '"]');
        if (addInput) {
          addInput.remove();
        } else {
          const removeParamName = role === 'kuroko' ? 'remove_kuroko_player_ids[]' : 'remove_record_only_player_ids[]';
          const input = document.createElement('input');
          input.type = 'hidden';
          input.name = removeParamName;
          input.value = pid;
          input.className = 'js-hidden-submit';
          form.appendChild(input);
        }
      } else if (newName) {
        const paramName = role === 'kuroko' ? 'new_kuroko_player_names[]' : 'new_record_only_player_names[]';
        const inputs = form.querySelectorAll('input[type="hidden"][name="' + paramName + '"]');
        for (let i = 0; i < inputs.length; i++) {
          if (inputs[i].value === newName) {
            inputs[i].remove();
            break;
          }
        }
      }
      chip.remove();
      updateRoleCardCount(role);
      roleDirty = true;
      updateSaveBar();
    });

    // チップ追加ボタン（イベント委譲）
    $(document).on('click.chipAdd', '.special-card .tc-add-chip', function() {
      const role = this.dataset.role;
      currentAddTarget = role;
      const nameTab = document.getElementById('roleAddTabName');
      const nameInput = document.getElementById('roleNewPlayerName');
      const addBtn = document.getElementById('roleNewPlayerAdd');
      if (role === 'record_only') {
        // 記録専門は名前で追加不可（アカウント登録済みプレイヤーのみ）
        if (nameTab) nameTab.hidden = true;
        activateRoleAddTab('roleAddTabPlayed');
        // プログラム的なタブ切り替えではタブクリックの再描画が走らないため、
        // 前回描画（黒子時の未絞り込みリスト等）を破棄してここで再描画する
        resetAndRenderRolePlayedPick();
      } else {
        if (nameTab) nameTab.hidden = false;
        activateRoleAddTab('roleAddTabName');
      }
      if (nameInput) nameInput.value = '';
      if (addBtn) addBtn.disabled = true;
      const inviteTab = document.getElementById('roleAddTabInvite');
      if (inviteTab) {
        if (configData && configData.isGuest) {
          inviteTab.setAttribute('hidden', '');
        } else {
          inviteTab.removeAttribute('hidden');
        }
      }
      window.TeamUiShared.openSheet('roleAddSheetOverlay');
      if (role !== 'record_only') {
        setTimeout(function() {
          if (nameInput) nameInput.focus();
        }, 100);
      }
    });

    // 名前で追加 - 入力
    $(document).on('input.roleNameInput', '#roleNewPlayerName', function() {
      const val = $(this).val().trim();
      $('#roleNewPlayerAdd').prop('disabled', val.length === 0);
    });

    // 名前で追加 - Enterキー
    $(document).on('keydown.roleNameKeydown', '#roleNewPlayerName', function(e) {
      if (e.key === 'Enter') {
        const oe = e.originalEvent;
        if (oe && (oe.isComposing || oe.keyCode === 229)) return;
        e.preventDefault();
        $('#roleNewPlayerAdd').trigger('click');
      }
    });

    // 名前で追加 - 追加ボタン
    $(document).on('click.roleNameAdd', '#roleNewPlayerAdd', function() {
      const nameVal = $('#roleNewPlayerName').val().trim();
      if (!nameVal) return;
      if (nameVal.length > 8) {
        window.TeamUiShared.showToast(window.Janreco.pluralize(i18n.toastPlayerNameMaxlen, 8), 'warn');
        return;
      }
      if (!currentAddTarget) return;
      if (currentAddTarget === 'record_only') {
        window.TeamUiShared.showToast(i18n.toastRecordOnlyNoName, 'warn');
        return;
      }
      const form = document.getElementById('bulk-edit-form');
      const paramName = currentAddTarget === 'kuroko' ? 'new_kuroko_player_names[]' : 'new_record_only_player_names[]';
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = paramName;
      input.value = nameVal;
      input.className = 'js-hidden-submit';
      form.appendChild(input);
      addChipToCard(currentAddTarget, null, nameVal);
      $('#roleNewPlayerName').val('');
      $('#roleNewPlayerAdd').prop('disabled', true);
      window.TeamUiShared.closeSheet('roleAddSheetOverlay');
      roleDirty = true;
      updateSaveBar();
      window.TeamUiShared.showToast(i18n.toastAdded.replace('%{name}', nameVal));
    });

    // 役割追加タブ切り替え
    [
      { tab: 'roleAddTabName', panel: 'roleAddPanelName' },
      { tab: 'roleAddTabPlayed', panel: 'roleAddPanelPlayed' },
      { tab: 'roleAddTabInvite', panel: 'roleAddPanelInvite' }
    ].forEach(function(t) {
      $(document).on('click.roleAddTab', '#' + t.tab, function() {
        activateRoleAddTab(t.tab);
        if (t.tab === 'roleAddTabName') {
          setTimeout(function() {
            const el = document.getElementById('roleNewPlayerName');
            if (el) el.focus();
          }, 50);
        }
        if (t.tab === 'roleAddTabPlayed') { resetAndRenderRolePlayedPick(); }
        if (t.tab === 'roleAddTabInvite') { loadRoleInviteQr(); }
      });
    });

    // 過去の対戦相手 - 候補行クリック
    $(document).on('click.rolePlayedRow', '#rolePlayedPickList .candidate-row', function() {
      if ($(this).hasClass('disabled')) return;
      const pid = parseInt($(this).data('pid'), 10);
      const idx = rolePlayedSelectedIds.indexOf(pid);
      if (idx !== -1) { rolePlayedSelectedIds.splice(idx, 1); }
      else { rolePlayedSelectedIds.push(pid); }
      renderRolePlayedPick();
      updateRolePlayedPickBtn();
    });

    // 過去の対戦相手 - ソート（最近）
    $(document).on('click.rolePlayedSortRecent', '#rolePlayedSortRecent', function() {
      rolePlayedSortMode = 'recent';
      $(this).addClass('is-active');
      $('#rolePlayedSortName').removeClass('is-active');
      renderRolePlayedPick();
    });

    // 過去の対戦相手 - ソート（名前）
    $(document).on('click.rolePlayedSortName', '#rolePlayedSortName', function() {
      rolePlayedSortMode = 'name';
      $(this).addClass('is-active');
      $('#rolePlayedSortRecent').removeClass('is-active');
      renderRolePlayedPick();
    });

    // 過去の対戦相手 - 確定ボタン
    $(document).on('click.rolePlayedConfirm', '#rolePlayedPickConfirm', function() {
      if (rolePlayedSelectedIds.length === 0) return;
      if (!currentAddTarget) return;
      const form = document.getElementById('bulk-edit-form');
      const paramName = currentAddTarget === 'kuroko' ? 'add_kuroko_player_ids[]' : 'add_record_only_player_ids[]';
      rolePlayedSelectedIds.forEach(function(pid) {
        const p = (configData.playedPlayers || []).find(function(pl) { return pl.id === pid; });
        if (!p) return;
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = paramName;
        input.value = pid;
        input.className = 'js-hidden-submit';
        form.appendChild(input);
        addChipToCard(currentAddTarget, pid, p.name);
      });
      roleDirty = true;
      updateSaveBar();
      window.TeamUiShared.showToast(window.Janreco.pluralize(i18n.addedCount, rolePlayedSelectedIds.length));
      rolePlayedSelectedIds = [];
      renderRolePlayedPick();
      updateRolePlayedPickBtn();
    });

    // 招待 - コピーボタン
    $(document).on('click.roleInviteCopy', '#roleInviteCopy', function() {
      if (!configData || !configData.authenticationUrl) return;
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(configData.authenticationUrl).then(function() {
          window.TeamUiShared.showToast(i18n.toastInviteCopied);
        }).catch(function() {
          window.TeamUiShared.showToast(i18n.toastCopyFailed, 'warn');
        });
      } else {
        window.TeamUiShared.showToast(i18n.toastCopyFailed, 'warn');
      }
    });

    // 招待 - 認証済み確認
    $(document).on('click.roleInviteCheck', '#roleInviteCheck', function() {
      const btn = this;
      if (btn.disabled) return;
      btn.disabled = true;
      if (!configData) { btn.disabled = false; return; }
      fetch(configData.checkAuthenticatedUsersUrl, {
        method: 'GET',
        headers: { 'Accept': 'application/json', 'X-CSRF-Token': csrfToken() },
        credentials: 'same-origin'
      })
      .then(function(res) { return res.json(); })
      .then(function(players) {
        if (!players || players.length === 0) {
          window.TeamUiShared.showToast(i18n.toastNoNewAuthenticated, 'warn');
          return;
        }
        const existingIds = [];
        const card = document.querySelector('.special-card[data-role="' + currentAddTarget + '"]');
        if (card) {
          card.querySelectorAll('.tc-member-chip').forEach(function(chip) {
            const pid = chip.dataset.playerId;
            if (pid) existingIds.push(parseInt(pid, 10));
          });
        }
        const form = document.getElementById('bulk-edit-form');
        const paramName = currentAddTarget === 'kuroko' ? 'add_kuroko_player_ids[]' : 'add_record_only_player_ids[]';
        let added = 0;
        players.forEach(function(p) {
          if (existingIds.indexOf(p.id) !== -1) return;
          const input = document.createElement('input');
          input.type = 'hidden';
          input.name = paramName;
          input.value = p.id;
          input.className = 'js-hidden-submit';
          form.appendChild(input);
          addChipToCard(currentAddTarget, p.id, p.name);
          added++;
        });
        if (added > 0) {
          roleDirty = true;
          updateSaveBar();
          window.TeamUiShared.showToast(window.Janreco.pluralize(i18n.toastAuthenticatedAdded, added));
        } else {
          window.TeamUiShared.showToast(i18n.toastNoNewAuthenticated, 'warn');
        }
      })
      .catch(function(e) {
        console.error('認証確認に失敗:', e);
        window.TeamUiShared.showToast(i18n.toastAuthCheckFailed, 'warn');
      })
      .finally(function() {
        btn.disabled = false;
      });
    });
  }

  // Turbolinksのライフサイクルにバインドする
  document.addEventListener('turbolinks:load', function () {
    init();
  });

  document.addEventListener('turbolinks:before-cache', function () {
    // トースト・保存バーのアニメーション状態をリセットする
    var toast = document.getElementById('toast');
    if (toast) toast.classList.remove('show');
    var saveBar = document.getElementById('saveBar');
    if (saveBar) saveBar.classList.remove('show');
    // disabledにしたフィールドを元に戻す（キャッシュに正しい状態を保存する）
    document.querySelectorAll('.team-card input:disabled, .team-card textarea:disabled').forEach(function (f) {
      f.disabled = false;
    });
    // beforeunloadリスナーを解除し、ガード状態をリセットする（他ページへの漏れを防ぐ）
    window.removeEventListener('beforeunload', onBeforeUnload);
    $(document).off('click.leaveGuard');
    // アコーディオンのイベントリスナーを解除する
    $(document).off('click.teamAccordion').off('keydown.teamAccordion');
    mobileQuery.removeEventListener('change', applyAccordionState);
    bypassGuard = false;
    pendingUrl = null;

    // 追加イベントの解除
    $(document).off('click.newTeamDelete');
    $(document).off('click.chipRemove');
    $(document).off('click.chipAdd');
    $(document).off('click.roleNameInput');
    $(document).off('input.roleNameInput');
    $(document).off('keydown.roleNameKeydown');
    $(document).off('click.roleNameAdd');
    $(document).off('click.roleAddTab');
    $(document).off('click.rolePlayedRow');
    $(document).off('click.rolePlayedSortRecent');
    $(document).off('click.rolePlayedSortName');
    $(document).off('click.rolePlayedConfirm');
    $(document).off('click.roleInviteCopy');
    $(document).off('click.roleInviteCheck');

    // 役割追加シートを閉じる
    window.TeamUiShared.closeSheet('roleAddSheetOverlay');

    // 変数リセット
    newTeamDirty = false;
    roleDirty = false;
    newTeamCounter = 0;
    currentAddTarget = null;
    rolePlayedSelectedIds = [];
    rolePlayedSortMode = 'recent';
  });
})();
